module.exports = __webpack_public_path__ + "img/成都大学附属医院.2a1c648e.png";